import { render } from "./AllCourses.vue?vue&type=template&id=18c87e67"
import script from "./AllCourses.vue?vue&type=script&lang=js"
export * from "./AllCourses.vue?vue&type=script&lang=js"

import "./AllCourses.vue?vue&type=style&index=0&id=18c87e67&scope=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__